
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { parsePhoneNumber } from 'react-phone-number-input'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) return '';
  
  try {
    // Ensure the phone number has a + prefix
    const phoneWithPrefix = !phoneNumber.startsWith('+') ? 
      `+${phoneNumber}` : phoneNumber;
      
    const parsed = parsePhoneNumber(phoneWithPrefix);
    if (parsed) {
      return parsed.format('E.164');
    }
    return phoneWithPrefix;
  } catch (err) {
    console.error('Error formatting phone number:', err);
    return phoneNumber;
  }
}

export async function checkPhoneNumberExists(
  supabaseClient: any, 
  phoneNumber: string, 
  currentUserId: string
): Promise<boolean> {
  if (!phoneNumber) return false;
  
  try {
    const formattedPhone = formatPhoneNumber(phoneNumber);
    
    const { data } = await supabaseClient
      .from('profiles')
      .select('id')
      .eq('phone_number', formattedPhone)
      .neq('id', currentUserId)
      .maybeSingle();
      
    return !!data;
  } catch (err) {
    console.error('Error checking if phone number exists:', err);
    return false;
  }
}
